import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { useParams } from "react-router-dom";
import Services from "../../api/service";
import ServiceSidebar from "./sidebar";
import Footer from "../../components/footer/Footer";
import Team from "../../api/team";
import { Link } from "react-router-dom";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const SeviceSinglePage = (props) => {
  const { slug } = useParams();

  const serviceDetails = Services.find((item) => item.slug === slug);

  return (
    <Fragment>
      <Navbar hclass={"wpo-header-style-2"} />
      <PageTitle pageTitle={serviceDetails.title} pagesub={"Service"} />
      <div className="wpo-service-single-area section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-12">
              <div className="wpo-service-single-wrap">
                <div className="wpo-service-single-item">
                  <div className="wpo-service-single-main-img">
                    <img src={serviceDetails.ssImg} alt="" />
                  </div>
                  <div className="wpo-service-single-title">
                    <h3>{serviceDetails.title}</h3>
                  </div>
                  <p>{serviceDetails.description}</p>
                  <div className="row mt-4">
                    <div className="col-md-6 col-sm-6 col-12">
                      <div className="wpo-p-details-img">
                        <img src={serviceDetails.ssImg2} alt="" />
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6 col-12">
                      <div className="wpo-p-details-img">
                        <img src={serviceDetails.ssImg3} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="service-dec">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="wpo-service-single-item list-widget">
                        <div className="wpo-service-single-title">
                          <h3>Our Capabilities</h3>
                        </div>
                        <p>
                          Massa volutpat odio facilisis purus sit elementum.
                          Non, sed velit dictum quam. Id risus pharetra est, at
                          rhoncus, nec ullamcorper tincidunt. Id aliquet duis
                          sollicitudin diam.
                        </p>
                        <ul>
                          <li>
                            Non saed velit dictum quam risus pharetra esta.
                          </li>
                          <li>
                            Id risus pharetra est, at rhoncus, nec ullamcorper
                            tincidunt.
                          </li>
                          <li>
                            Hac nibh fermentum nisi, platea condimentum cursus.
                          </li>
                          <li>
                            Massa volutpat odio facilisis purus sit elementum.
                          </li>
                          <li>Elit curabitur amet risus bibendum.</li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="wpo-service-single-item list-widget">
                        <div className="wpo-service-single-title">
                          <h3>Our Work Process</h3>
                        </div>
                        <p>
                          Massa volutpat odio facilisis purus sit elementum.
                          Non, sed velit dictum quam. Id risus pharetra est, at
                          rhoncus, nec ullamcorper tincidunt. Id aliquet duis
                          sollicitudin diam.
                        </p>
                        <ul>
                          <li>
                            Non saed velit dictum quam risus pharetra esta.
                          </li>
                          <li>
                            Id risus pharetra est, at rhoncus, nec ullamcorper
                            tincidunt.
                          </li>
                          <li>
                            Hac nibh fermentum nisi, platea condimentum cursus.
                          </li>
                          <li>
                            Massa volutpat odio facilisis purus sit elementum.
                          </li>
                          <li>Elit curabitur amet risus bibendum.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpo-team-section-s2 Specialist dentist">
                  <div className="wpo-service-single-title">
                    <h3>Our {serviceDetails.title} Specialist</h3>
                  </div>
                  <div className="team-wrap">
                    <div className="row">
                      {Team.slice(0, 3).map((team, tm) => (
                        <div
                          className="col-xl-4 col-lg-6 col-md-6 col-12"
                          key={tm}
                        >
                          <div className="team-single">
                            <div className="team-boder-shapes-1">
                              <div className="team-single-img">
                                <img src={team.tImg} alt="" />
                              </div>
                              <div className="team-single-text">
                                <h2>
                                  <Link
                                    onClick={ClickHandler}
                                    to={`/team-single/${team.slug}`}
                                  >
                                    {team.name}
                                  </Link>
                                </h2>
                                <span>{team.title}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ServiceSidebar />
          </div>
        </div>
      </div>
      <Footer footerClass={"wpo-site-footer-s2"} />
      <Scrollbar />
    </Fragment>
  );
};
export default SeviceSinglePage;
